import src from "IMAGE";
export default { src, width: 2000, height: 200, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAI0lEQVR42mNg4+ITZuTgFwFhBnY+IQZOIXEGLmFJMM0pKA4AFu4BfEkbyzsAAAAASUVORK5CYII="};
